import { useState, useEffect, useRef } from "react";
import { ISession } from "../../../../../models/session";

export const useSessionState = (session: ISession[] | ISession, loggedUser: any, folderList: any, language: string) => {
    const [sessions, setSessions] = useState<ISession[]>([]);
    const [isSessionOpen, setIsSessionOpen] = useState({});
    const [isUserRegistered, setIsUserRegistered] = useState({});
    const [sessionUpdate, setSessionUpdate] = useState({});
    const [entityLanguage, setEntityLanguage] = useState<string>("common");
    const [folderListBySession, setFolderListBySession] = useState({});
    const [dateColWidth, setDateColWidth] = useState<number>(0);
    const dateColRef = useRef<HTMLDivElement>(null);    

    useEffect(() => {
        setSessions(!Array.isArray(session) ? [session] : session);
    }, [session]);

    useEffect(() => {
        const registeredClasses = {};
        loggedUser.classes?.forEach((cls: any) => {
            sessions.forEach((sessionItem) => {
                if (cls._id === sessionItem._id) {
                    registeredClasses[sessionItem._id] = true;
                }
            });
        });
        setIsUserRegistered(registeredClasses);
        setEntityLanguage(language);
    }, [loggedUser, sessions, language]);

    useEffect(() => {
        const folderBySession = folderList.reduce((acc, folder) => {
            folder.sessions.forEach((sessionItem: any) => {
                sessions.forEach((session) => {
                    if (sessionItem.sessionId === session._id) {
                        if (!acc[session._id]) {
                            acc[session._id] = [];
                        }
                        acc[session._id].push(folder);
                    }
                });
            });
            return acc;
        }, {});
        setFolderListBySession(folderBySession);
    }, [folderList, sessions]);

    useEffect(() => {
        if (dateColRef.current) {
            setDateColWidth(dateColRef.current.offsetWidth);
        }
    }, [dateColRef.current]);

    return {
        sessions,
        isSessionOpen,
        setIsSessionOpen,
        isUserRegistered,
        setIsUserRegistered,
        sessionUpdate,
        setSessionUpdate,
        entityLanguage,
        folderListBySession,
        dateColWidth,
        dateColRef
    };
};
